export default "__VITE_ASSET__CkKYhnbq__"